<h1 class="h6 visible-title">Halka Arz - Temettü Hisseleri</h1>
<div class="container pairblank">
  <div>
    <div class="row mt-2 mb-2">
      <div class="col-md-8">
        <!-- carousel codes start -->
        <ngb-carousel #carousel [interval]="2000" [pauseOnHover]="pauseOnHover" [pauseOnFocus]="pauseOnFocus"
                      (slide)="onSlide($event)">
          <ng-template ngbSlide *ngFor="let carousel of carouselList; index as cl">
            <div *ngIf="carousel.type == 'ANALYSIS'" class="carousel-caption">
              <h4>Analiz Yazısı</h4>
              <hr>
              <h3>{{carousel.title}}</h3>
            </div>
            <div *ngIf="carousel.type == 'REAL'" class="carousel-caption">
              <h4>Yeni Halka Arz!</h4>
              <hr>
              <h3>{{carousel.title}}</h3>
            </div>
            <div *ngIf="carousel.type == 'DRAFT'" class="carousel-caption">
              <h4>Halka Arz Olması Bekleniyor!</h4>
              <hr>
              <h3>{{carousel.title}}</h3>
            </div>
            <a href={{carousel.url}} title="{{carousel.title}}" target="_blank"
               rel="nofollow noopener noreferrer">
              <div class="picsum-img-wrapper">
                <img src="https://www.halkaarz.info/tr/halka-arz-anasayfa-1.webp" alt={{carousel.title}} />
              </div>
            </a>
          </ng-template>
        </ngb-carousel>
        <!-- carousel codes end -->
      </div>
      <div class="col-md-4 flex-container">
        <div class="col-12">

          <div class="entry" *ngFor="let sidebar of sidebarList; index as i; trackBy: trackByFnSidebar">
            <a href={{sidebar.url}}  title="{{sidebar.title}}">
              <div class="card mb-0">
                <div class="row g-0">
                  <div class="col-8">
                    <div class="card-body ">
                      <div class="h5 card-title" style="font-size: 16px; color:black;">
                        <p>{{sidebar.title}}</p></div>
                    </div>
                  </div>
                  <div class="col-4  p-2" >
                    <div class="d-flex justify-content-end">
                      <picture>
                        <source media="(max-width: 100px)" srcset="{{domainURL}}katılım-fonu-nedir-1.webp" />
                        <source media="(min-width: 100px)" srcset="{{domainURL}}katılım-fonu-nedir-1.webp" />
                        <img loading="lazy" width="100px" height="80px" src="katılım-fonu-nedir-1.webp" alt="{{sidebar.title}}" title="{{sidebar.title}}">
                      </picture>
                    </div>
                    <div class="entry--overlay"></div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <!-- carousel sidebar ends   -->
      </div>

    </div>
    <hr>
    <!-- ipo list started -->
    <div class="two">
      <h3 class="h3-mr" style="color: teal;"><a href="/ipo-calendar">Halka Arz Duyuruları</a>
        <span>Şirketlerin Halka Arz Duyuruları</span>
      </h3>
    </div>
    <div class="row align-items-flex-start g-2 flex-container" style="grid-auto-flow: column;" bis_skin_checked="1">
      <div class="col-md-6">
        <div class="card mt-3 mb-3" style="background-color: #293138;">
          <div class="row">
            <div class="col-10">
              <h3 class="card-title m-3 text-white h4">Yeni Halka Arzlar</h3>
            </div>
            <div class="col-2 mr-2">
              <a [routerLink]="['/ipo-calendar']" title="Halka Arz Takvimi"><fa-icon [icon]="faElipsis" class="fa-2x pt-2"></fa-icon></a>
            </div>
          </div>
          <ul class="list-ic vertical">
            <ng-template ngFor let-iposReal [ngForOf]="ipoRealList" let-i="index" [ngForTrackBy]="trackByFnIpoReal">
              <li class="p-2 pt-3" [ngStyle]="{'background-color': i%2==0? '' : '#3b4048'}">
                <div class="row">
                  <div class="col-8">
                    <img class="avatar-image" src="{{iposReal?.companyImg}}">
                    <a href={{iposReal.url}} class="text-white p-2 h6"> {{iposReal.code}}</a>
                  </div>
                  <div class="col-4" style="margin: -0.50rem!important;text-align: end">
                    <button type="button" class="btn text-white" [ngStyle]="{'background-color':'#d48e10' }"
                            [ngStyle]="{'background-color': iposReal?.completeStatus? '#d48e10' : '#c44741'}">
                      <a href={{iposReal.url}}>{{iposReal?.completeStatus?'Tamamlandı':'Yeni !'}}</a>
                    </button>
                  </div>
                </div>
              </li>
            </ng-template>
          </ul>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card mt-3 mb-3" style="background-color:#293138;">
          <div class="row">
            <div class="col-10">
              <h3 class="card-title m-3 text-white h4">Halka Arz Olması Beklenenler</h3>
            </div>
            <div class="col-2 mr-2">
              <a [routerLink]="['/ipo-calendar']" title="Devamını Oku"><fa-icon [icon]="faElipsis" class="fa-2x pt-2"></fa-icon></a>
            </div>
          </div>
          <ul class="list-ic vertical">
            <ng-template ngFor let-iposDraft [ngForOf]="ipoDraftList" let-i="index" [ngForTrackBy]="trackByFnIpoDraft">
              <li class="p-2 pt-3" [ngStyle]="{'background-color': i%2==0? '' : '#3b4048'}">
                <div class="row">
                  <div class="col-7">
                    <img class="avatar-image" src="{{iposDraft?.companyImg}}">
                    <a *ngIf="!iposDraft?.code" href={{iposDraft.url}}
                       class="p-2 h6">{{iposDraft?.name |
                      slice:0:15}}{{(iposDraft?.name).length>6?' ...':''}}</a>
                    <a *ngIf="iposDraft?.code" href={{iposDraft.url}} class="p-2 h6">
                      {{iposDraft?.code}}</a>
                  </div>
                  <div class="col-5" style="margin: -0.3rem!important;text-align: end">
                    <button type="button" class="btn text-white"
                            [ngStyle]="{'background-color':'#1a5571' }">
                      <a href={{iposDraft.url}}>Hazırlanıyor</a>
                    </button>
                  </div>
                </div>
              </li>
            </ng-template>
          </ul>
        </div>
      </div>
    </div>
    <!-- ipo list ended -->
    <hr>
    <!-- info list started -->
    <div class="two mb-2" bis_skin_checked="1">
      <h3 class="h3-mr" style="color: #ED9E01;"><a href="/info">Borsa Terimleri</a>
        <span>Borsa Hakkında Bilinmesi Gereken Terimler</span>
      </h3>
    </div>
    <div class="row align-items-stretch g-2 py-2" style="grid-auto-flow: column;">
      <ng-template ngFor let-info [ngForOf]="infoList" let-i="index" [ngForTrackBy]="trackByFnInfo">
        <div class="col">
          <div class="container-mrr mx-1" id="rcorners2" style="border-style: ridge; height:100%;">
            <div class="card-mr text-shadow-1" data-label="Gerekli Bilgiler"
                 style="display:flex; height:100%;">
              <!-- <div class="overlay-mr"></div> -->
              <a href={{info.url}}>
                <div class="card__container">
                  <a href={{info.url}}>
                    <h6 class="card__header mt-5 h5"
                        style="font-weight:bold; z-index: 1; line-height:25px;">
                      {{info.title}}
                    </h6>
                  </a>
                  <div style="position:absolute; bottom:10px;">
                    <a href={{info.url}} title={{info.title}} class="stretched-link"
                       style="z-index: 1;">Devamını oku</a>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
    <!-- info list ended -->
    <hr>
    <!-- dividend list started -->
    <div class="two">
      <h3 class="h3-mr" style="color: teal;">
        <a href="/dividend">Temettü Duyuruları</a>
        <span>Şirketlerin Temettü Kararı Duyuruları</span>
      </h3>
    </div>
    <div class="row row-cols-1 row-cols-lg-3 align-items-stretch g-2 py-3 flex-container"
         style="grid-auto-flow: column;" bis_skin_checked="1">
      <div class="col-lg-6 col-md-6">
        <div class="card mt-3 mb-3" style="background-color:#293138">
          <h4 class="card-title m-3 text-white h5">Yıllara Göre En Çok Temettü Veren Hisseler</h4>
          <div class="col">
            <nav>
              <div class="nav nav-tabs mb-3" id="nav-tab" role="tablist">
                <ng-template ngFor let-year [ngForOf]="years" let-i="index" [ngForTrackBy]="trackByFnInfo">
                  <button class="nav-link public-offering-title-color" (click)="getDividendYear(year)"   [ngClass]="{ 'active': i==0}" data-bs-toggle="tab" type="button" role="tab" aria-selected="true"
                          [attr.id]="'nav-' + year+'-tab'"
                          [attr.data-bs-target]="'#nav-' + year"
                          [attr.aria-controls]="'nav-' + year">{{year}}</button>
                </ng-template>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              <ng-template ngFor let-year [ngForOf]="years" let-i="index" [ngForTrackBy]="trackByFnInfo">
                <div class="tab-pane fade "  [ngClass]="{ 'active show': i==0}" [attr.id]="'nav-'+year" role="tabpanel"
                     [attr.aria-labelledby]="'nav-' + year+'-tab'">
                  <ul class="list-ic-dividend vertical">
                    <ng-template ngFor let-dividendIncrease [ngForOf]="dividendIncreaseList"
                                 let-i="index+1" [ngForTrackBy]="trackByFnDividendIncrease">
                      <a href={{dividendIncrease.url}} title="{{dividendIncrease?.code}} 2022 Temettü">
                        <li  [ngStyle]="{'background-color': i%2==0? '' : '#1a5571'}">
                          <div class="row">
                            <div class="col-md-3 col-sm-3 col-3">
                              <span>{{i}}</span>
                            </div>
                            <div class="col-md-5 col-sm-5 col-3 py-4">
                              <a href={{dividendIncrease.url}} title="{{dividendIncrease?.code}} 2022 Temettü" class="h6 ml-3"> {{dividendIncrease?.code}}</a>
                            </div>
                            <div class="col-md-4 col-sm-4 col-6 py-4">
                              <p>{{dividendIncrease.cashDvdnd | currency:'TRY'}}</p>
                            </div>
                          </div>
                        </li>
                      </a>
                    </ng-template>
                  </ul>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 ">
        <div class="card mt-3 mb-3">
          <h4 class="card-title m-3 h5" style="color:#293138; font-weight: 700px;"><a
            href="dividend/year/{{year}}/{{month[1]}}"> {{month[0]}} Ayında Temettü Verecek Hisseler</a>
          </h4>
          <div class="tab-pane fade show active" style="overflow-x:auto;">
            <table class="table table-hover table-responsive table-striped ">
              <thead>
              <tr class="dividend-title text-white" style="background: #1a5571;">
                <th scope="col" id="code" class="tables">Hisse
                </th>
                <th scope="col" id="cashDvdndDt" class="tables">Ödeme Tarihi
                </th>
                <th scope="col" id="regstrDt" class="tables">Duyuru Tarihi
                </th>
                <th scope="col" id="status" class="tables">Gerçekleşme Durumu
                </th>
              </tr>
              </thead>
              <tbody>
              <ng-template ngFor let-dividend [ngForOf]="dividendList" let-i="index"
                           [ngForTrackBy]="trackByFnDividend">
                <tr>
                  <td><a href="/dividend/{{dividend?.url}}"
                         title="{{dividend?.code}}">{{dividend.code}}</a></td>
                  <td>{{dividend.cashDvdndDt| date:'d MMMM y'}}</td>
                  <td>{{dividend.regstrDt| date:'d MMMM y'}}</td>
                  <td
                    [ngStyle]="{'color': dividend.completeStatus? '#198754' : '#ec0303'}">
                    {{dividend.completeStatus? 'Tamamlandı' : 'Bekleniyor..'}}</td>
                </tr>
              </ng-template>
              </tbody>
            </table>
            <div class="row" style="margin-top: 20px;">
              <div class="col-sm-12 col-md-12 col-lg-12 clearfix mt-10 text--center">
                <app-mansel-pagination [pageIn]="pageInfo"
                                       (setManselPaginePageEvent)="setPage($event)"></app-mansel-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- dividend list ended -->
    <!-- dividend analysis list started-->
    <div class="row flex-container container-mrr mx-2">
      <div class="row p-0">
        <ng-template ngFor let-dividendAnalysis [ngForOf]="dividendAnalysisList" let-i="index" class="row g-0"
                     [ngForTrackBy]="trackByFnAnalysis">
          <div class="col-md-3 p-0">
            <a href="{{dividendAnalysis?.url}}" title="{{dividendAnalysis?.title}}">
              <!-- Post-->
              <div class="post-module">
                <!-- Thumbnail-->
                <div class="thumbnail">
                  <div class="date">
                    <div class="day">27</div>
                    <div class="month">Mar</div>
                  </div><img style="width:400px;height:300px"
                             src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/169963/photo-1429043794791-eb8f26f44081.jpeg">
                </div>
                <!-- Post Content-->
                <div class="post-content">
                  <div class="category">Analiz</div>
                  <h1 class="title">Temettü</h1>
                  <h2 class="sub_title">{{dividendAnalysis.title}}
                  </h2>
                </div>
              </div>
            </a>
          </div>
        </ng-template>
      </div>
    </div>
    <!-- dividend analysis list ended-->
    <hr>
    <div class="two">
      <h3 class="h3-mr" style="color: #63a802"><a href="/capital-increase"
                                                  title="Sermaye Artırımı Duyuruları">Sermaye Artırımı Duyuruları</a>
        <span>Sermaye Artırımı Kararı Alan Şirketlerin Duyuruları</span>
      </h3>
    </div>
    <!-- sermaye artırımı started -->

    <div class="row row-cols-1 row-cols-lg-3 align-items-stretch flex-container" style="grid-auto-flow: column;">
      <div  bis_skin_checked="1">
        <div class="card mt-3 mb-3" style="background-color: #293138;">
          <div class="row">
            <div class="col-10">
              <h4 class="card-title m-3 text-white">Sermaye Artırımı Yapacak Şirketler</h4>
            </div>
            <div class="col-2 mr-2">
              <a [routerLink]="['/ipo-calendar']" title="Sermaye Arttırımı Duyuruları"><fa-icon [icon]="faElipsis" class="fa-2x pt-2"></fa-icon></a>
            </div>
          </div>
          <ul class="list-ic vertical">
            <ng-template ngFor let-capIncrease [ngForOf]="capitalIncreaseList" let-i="index" [ngForTrackBy]="trackByFnCapitalIncrease">
              <li class="p-2 pt-3" [ngStyle]="{'background-color': i%2==0? '' : '#3b4048'}">
                <div class="row">
                  <div class="col-8">
                    <img class="avatar-image" src="{{capIncrease?.companyImg}}">
                    <a href={{capIncrease.url}} class="text-white p-2 h6"> {{capIncrease.code}}</a>
                  </div>
                  <div class="col-4" style="margin: -0.50rem!important;text-align: end">
                    <button type="button"
                            class="btn text-white"
                            [ngStyle]="{'background-color': capIncrease?.capitalIncreaseType == 'FREE'? '#d48e10' : (capIncrease?.capitalIncreaseType == 'FREE'? '#c44741':'#1a5571')}">
                      <a href={{capIncrease.url}}>{{capIncrease?.capitalIncreaseType == 'FREE'?'Bedelsiz':(capIncrease?.capitalIncreaseType == 'DEDICATED'?'Tahsisli':'Bedelli')}}</a>
                    </button>
                  </div>
                </div>
              </li>
            </ng-template>
          </ul>
        </div>
      </div>
      <div class="col-lg-7 col-md-7 g-3 ">
        <div class="entry" *ngFor="let analysisList of analysisList; index as i; trackBy: trackByFnAnalysis">
          <a [routerLink]="[analysisList?.url]" title="{{analysisList.title}}">
            <div class="card mb-0">
              <div class="row g-0">
                <div class="col-8">
                  <div class="card-body ">
                    <div class="h5 card-title" style="font-size: 16px; color:black;">
                      <p>{{analysisList.title}}</p></div>
                    <div class="entry--date" style="font-size: 14px;">{{analysisList?.subTitle |
                      slice:0:40}}{{(analysisList?.subTitle).length>6?' ...':''}}</div>
                  </div>
                </div>
                <div class="col-4  p-2" >
                  <div class="d-flex justify-content-end">
                    <picture>
                      <source media="(max-width: 100px)" srcset="{{domainURL}}katılım-fonu-nedir-1.webp" />
                      <source media="(min-width: 100px)" srcset="{{domainURL}}katılım-fonu-nedir-1.webp" />
                      <img loading="lazy" width="100px" height="80px" src="katılım-fonu-nedir-1.webp" alt="{{analysisList.title}}" title="{{analysisList.title}}">
                    </picture>
                  </div>
                  <div class="entry--overlay"></div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <!-- sermaye artırımı ended -->
    <hr>
    <!-- hisse önerileri started -->
    <div>
      <div class="two">
        <h3 class="h3-mr" style="color:#ED9E01;">Aracı Kurum Hisse Önerileri
          <span>Hisse Önerileri Yapan Aracı Kurumlar Listesi</span>
        </h3>
      </div>
      <div class="row">
        <div class="col-md-8">
          <div class="card mt-3 mb-3 mx-8">
            <div class="col-md-10">
              <a [routerLink]="['/stock-recommendation']" style="color:#293138"
                 title="Aracı Kurum Hisse Önerileri">
                <h3 class="card-title m-3 ">Hisse Önerisi Yapan Aracı Kurumlar </h3>
              </a>
            </div>
            <div class="entry" *ngFor="let stockRecommendation of recommendationList; index as i; trackBy: trackByFnStockRecommendation">
              <a [routerLink]="[stockRecommendation?.url]" title="{{stockRecommendation.brokerageFirmName}}">
                <div class="card mb-0">
                  <div class="row g-0">
                    <div class="col-8">
                      <div class="card-body ">
                        <div class="h5 card-title" style="font-size: 16px; color:black;">
                          <p>{{stockRecommendation.brokerageFirmName}}</p></div>
                        <div class="entry--date" style="font-size: 14px;">{{stockRecommendation.date
                          | date:'EEEE, MMMM d, y'}}</div>
                      </div>
                    </div>
                    <div class="col-4  p-2" >
                      <div class="d-flex justify-content-end">
                        <picture>
                          <source media="(max-width: 100px)" srcset="{{domainURL}}katılım-fonu-nedir-1.webp" />
                          <source media="(min-width: 100px)" srcset="{{domainURL}}katılım-fonu-nedir-1.webp" />
                          <img loading="lazy" width="100px" height="80px" src="katılım-fonu-nedir-1.webp" alt="{{stockRecommendation?.brokerageFirmName}}" title="{{stockRecommendation?.brokerageFirmName}}">
                        </picture>
                      </div>
                      <div class="entry--overlay"></div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div>
            <app-draft-dividend [toYear]="year"></app-draft-dividend>
            <app-draft-month [toYear]="year"></app-draft-month>
          </div>
        </div>

      </div>
      <!-- <div class="col-3 card mt-3 mb-3 bg-dark">
          <h3 class="text-white card-title m-3 text-white h4">Getiri Potansiyeli En Yüksekler</h3>
          <hr class="bg-white">
          <ul>
              <li class="list-marker p-2 h5 text-white">BIMAS</li>
              <li class="list-marker p-2 h5 text-white">FROTO</li>
              <li class="list-marker p-2 h5 text-white">ASELS</li>
              <li class="list-marker p-2 h5 text-white">SASA</li>
              <li class="list-marker p-2 h5 text-white">EGYO</li>
          </ul>
      </div> -->
    </div>
    <!-- hisse önerileri ended -->
  </div>

</div>
